import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppRoutes } from "config/router";
import AppLink from "../AppLink";
import HTMLCode from "../HTMLCode";
import Translate from "../Translate";

export type TabNavLinkPropsType = {
    to: string | AppRoutes,
    params?: Record<string, any>
    text: string,
    icon: IconDefinition,
    iconViewBox?: string,
    hidden?: boolean | (() => boolean),
    match?: RegExp | ((location: string) => boolean) | string
}

const TabNavLink = (props: TabNavLinkPropsType) => {
    var icon = props.iconViewBox ? <FontAwesomeIcon viewBox={props.iconViewBox} className="md:hidden lg:inline-block" icon={props.icon} /> : <FontAwesomeIcon className="md:hidden lg:inline-block" icon={props.icon} />;
    return (
        <AppLink to={props.to} params={props.params} className=" overflow-hidden text-ellipsis whitespace-nowrap" >
            <span>
                {icon}
                <span className="hidden md:inline-block">
                    <HTMLCode />
                    <HTMLCode />
                    <Translate i18nKey={props.text} />
                </span>
            </span>
        </AppLink>
    );
};

export default TabNavLink;
